import { motion } from 'motion/react';
import clsx from 'clsx';
import { cardHover } from '@/lib/animations';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'sm' | 'md' | 'lg';
}

export function Card({ children, className, hover = false, padding = 'md' }: CardProps) {
  const paddings = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const baseStyles = clsx(
    'bg-white dark:bg-slate-800 rounded-2xl border border-gray-200 dark:border-slate-700',
    paddings[padding],
    className
  );

  if (hover) {
    return (
      <motion.div className={baseStyles} {...cardHover}>
        {children}
      </motion.div>
    );
  }

  return <div className={baseStyles}>{children}</div>;
}
